// extracted by mini-css-extract-plugin
module.exports = {"options-group-divider":"SelectBody_options-group-divider__yZXCY"};